export enum ActiveMenuItem {
  ACTIVITY_REFRESH = 'ACTIVITY_REFRESH',
  ACTIVITY_PRINT = 'ACTIVITY_PRINT',
  ACTIVITY_FILTER = 'ACTIVITY_FILTER',
  ACTIVITY_SAVE = 'ACTIVITY_SAVE',
  ACTIVITY_DAILY = 'ACTIVITY_DAILY',
  ACTIVITY_WEEKLY = 'ACTIVITY_WEEKLY',
  ACTIVITY_MONTHLY = 'ACTIVITY_MONTHLY',
  ACTIVITY_ANNUAL = 'ACTIVITY_ANNUAL',
  ACTIVITY_ATTESTATION = 'ACTIVITY_ATTESTATION',
  ACTIVITY_COMPARE_DRIVERS = 'ACTIVITY_COMPARE_DRIVERS',
  ACTIVITY_COMPARE_ACTIVITIES = 'ACTIVITY_COMPARE_ACTIVITIES',
  ACTIVITY_READ = 'ACTIVITY_READ',
  ACTIVITY_DETAILS = 'ACTIVITY_DETAILS',

  VEHICLE_BASICS_SINGLE = 'VEHICLE_BASICS_SINGLE',
  VEHICLE_ACTIVITY_ANNUAL = 'VEHICLE_ACTIVITY_ANNUAL',
  VEHICLE_ACTIVITY_DAILY = 'VEHICLE_ACTIVITY_DAILY',
  VEHICLE_ACTIVITY_WEEKLY = 'VEHICLE_ACTIVITY_WEEKLY',
  VEHICLE_SLOT_1 = 'VEHICLE_SLOT_1',
  VEHICLE_SLOT_2 = 'VEHICLE_SLOT_2',
  SPEED_CHART = 'SPEED_CHART',

  BASICS_SINGLE = 'BASICS_SINGLE',
  BASICS_GROUP = 'BASICS_GROUP',
  BASICS_ADD_CONTRACT = 'BASICS_ADD_CONTRACT',
  BASICS_ADD_CONTRACT_FROM_TEMPLATE = 'BASICS_ADD_CONTRACT_FROM_TEMPLATE',
  BASICS_ADD_ANNEX = 'BASICS_ADD_ANNEX',
  BASICS_ADD_CONTRACT_TEMPLATE = 'BASICS_ADD_CONTRACT_TEMPLATE',
  BASICS_CONTRACTS = 'BASICS_CONTRACTS',
  BASICS_REFRESH = 'BASICS_REFRESH',
  BASICS_CREATE = 'BASICS_CREATE',
  BASICS_SHOW_LIST = 'BASICS_SHOW_LIST',

  DELEGATION_BASIC = 'DELEGATION_BASIC',
  DELEGATION_GROUP = 'DELEGATION_GROUP',
  DELEGATION_REFRESH = 'DELEGATION_REFRESH',
  DELEGATION_PRINT = 'DELEGATION_PRINT',
  DELEGATION_PRINT_SETTLEMENT = 'DELEGATION_PRINT_SETTLEMENT',
  DELEGATION_REPORT = 'DELEGATION_REPORT',
  DELEGATION_PRINT_SPECIFIC = 'DELEGATION_PRINT_SPECIFIC',
  DELEGATION_PRINT_INVOICES = 'DELEGATION_PRINT_INVOICES',
  DELEGATION_NEW = 'DELEGATION_NEW',
  DELEGATION_NEW_GROUPED = 'DELEGATION_NEW_GROUPED',
  DELEGATION_FILTER_ONLY_POLISH = 'DELEGATION_FILTER_ONLY_POLISH',
  DELEGATION_FILTER_STARTED = 'DELEGATION_FILTER_STARTED',
  DELEGATION_FILTER_ENDED = 'DELEGATION_FILTER_ENDED',
  DELEGATION_FILTER_CALCULATED = 'DELEGATION_FILTER_CALCULATED',
  DELEGATION_FILTER_SETTLEMENT_MONTH = 'DELEGATION_FILTER_SETTLEMENT_MONTH',
  DELEGATION_FILTER_MODIFIED = 'DELEGATION_FILTER_MODIFIED',

  TIMESHEET_SINGLE = 'TIMESHEET_SINGLE',
  TIMESHEET_GROUP = 'TIMESHEET_GROUP',
  TIMESHEET_DETAILED_VIEW = 'TIMESHEET_DETAILED_VIEW',
  TIMESHEET_CALCULATE = 'TIMESHEET_CALCULATE',
  TIMESHEET_CLEAR = 'TIMESHEET_CLEAR',
  TIMESHEET_AMOUNTS_PREVIEW = 'TIMESHEET_AMOUNTS_PREVIEW',
  TIMESHEET_FOREIGN_AMOUNTS = 'TIMESHEET_FOREIGN_AMOUNTS',

  TIMESHEET_REFRESH = 'TIMESHEET_REFRESH',
  TIMESHEET_PRINT = 'TIMESHEET_PRINT',
  TIMESHEET_SAVE = 'TIMESHEET_SAVE',
  TIMESHEET_REMOVE = 'TIMESHEET_REMOVE',
  TIMESHEET_SCHEDULE = 'TIMESHEET_SCHEDULE',
  TIMESHEET_BONUS_CONFIGURATION = 'TIMESHEET_BONUS_CONFIGURATION',
  TIMESHEET_REWARD_IMPORT = 'TIMESHEET_REWARD_IMPORT',

  TIMESHEET_PRINT_FOREIGN_AMOUNTS = 'TIMESHEET_PRINT_FOREIGN_AMOUNTS',
  TIMESHEET_PRINT_AMOUNTS = 'TIMESHEET_PRINT_AMOUNTS',
  TIMESHEET_PRINT_LUMPSUM_SETTLEMENT = 'TIMESHEET_PRINT_LUMPSUM_SETTLEMENT',
  TIMESHEET_PRINT_REWARDS_TO_ACCEPT = 'TIMESHEET_PRINT_REWARDS_TO_ACCEPT',
  TIMESHEET_PRINT_MOBILITY_PACKAGE_PAYROLL = 'TIMESHEET_PRINT_MOBILITY_PACKAGE_PAYROLL',

  VIOLATION_BASIC = 'VIOLATION_BASIC',
  VIOLATION_REFRESH = 'VIOLATION_REFRESH',
  VIOLATION_PRINT = 'VIOLATION_PRINT',
  VIOLATION_PRINT_STATEMENT = 'VIOLATION_PRINT_STATEMENT',
  VIOLATION_GROUP = 'VIOLATION_GROUP',
  VIOLATION_CALCULATE = 'VIOLATION_CALCULATE',

  PRINTOUT_DRIVER = 'PRINTOUT_DRIVER',
  PRINTOUT_VEHICLE = 'PRINTOUT_VEHICLE',
  PRINTOUT_PDF = 'PRINTOUT_PDF',
  PRINTOUT_CSV = 'PRINTOUT_CSV',

  EXPORT_BASE = 'EXPORT_BASE',
  EXPORT_IMI = 'EXPORT_IMI',

  IMPORT_FROM_FILE = 'IMPORT_FROM_FILE',
  IMPORT_FROM_CARD = 'IMPORT_FROM_CARD',
  IMPORT_FROM_ANALOG_TACHOGRAPH = 'IMPORT_FROM_ANALOG_TACHOGRAPH',
  IMPORT_FROM_SCANNER = 'IMPORT_FROM_SCANNER',
  IMPORT_ACTIVITY_FROM_FILE = 'IMPORT_ACTIVITY_FROM_FILE',
  IMPORT_ABSENCES_FROM_FILE = 'IMPORT_ABSENCES_FROM_FILE',
  IMPORT_BORDER_CROSSINGS_FROM_FILE = 'IMPORT_BORDER_CROSSINGS_FROM_FILE',
  IMPORT_BORDER_CROSSINGS_FROM_TRIMBLE = 'IMPORT_BORDER_CROSSINGS_FROM_TRIMBLE',
  IMPORT_BORDER_CROSSINGS_FROM_TMS_NAVIGATOR = 'IMPORT_BORDER_CROSSINGS_FROM_TMS_NAVIGATOR',
  IMPORT_BORDER_CROSSINGS_FROM_TOM_TOM = 'IMPORT_BORDER_CROSSINGS_FROM_TOM_TOM',
  IMPORT_BORDER_CROSSINGS_FROM_WEB_FLEET = 'IMPORT_BORDER_CROSSINGS_FROM_WEB_FLEET',

  IMPORT_CURRENT_FILES = 'IMPORT_CURRENT_FILES',
  IMPORT_PREVIOUS_FILES = 'IMPORT_PREVIOUS_FILES',
  IMPORT_DDD = 'IMPORT_DDD',
  IMPORT_GPS = 'IMPORT_GPS',
  IMPORT_MINIMAL_WAGES = 'IMPORT_MINIMAL_WAGES',
  IMPORT_EDGE_DATES = 'IMPORT_EDGE_DATES',

  ALERT_BASE = 'ALERT_BASE',
  ALERT_NEW = 'ALERT_NEW',
  ALERT_PRINT = 'ALERT_PRINT',
  ALERT_FILTER_UPCOMING = 'ALERT_FILTER_UPCOMING',
  ALERT_FILTER_ONLY_VISIBLE = 'ALERT_FILTER_ONLY_VISIBLE',

  DRIVER_LIST_LIST = 'DRIVER_LIST_LIST',
  DRIVER_LIST_COLUMNS = 'DRIVER_LIST_COLUMNS',
  DRIVER_LIST_PRINT = 'DRIVER_LIST_PRINT',
  DRIVER_LIST_CLOSE = 'DRIVER_LIST_CLOSE',
}
